import { deleteSubscription } from '$utils/pushNotifications';
import { getMetriAddress } from '$utils/getMetriAddress';
import { stateCirclesBasicInfoOnboardingData } from '$states/stateCirclesBasicInfoOnboardingData.svelte';
import { getPayAddress } from '$utils/getPayAddress';
import { deleteFCMToken } from '$lib/firebase/fcm';

export const logoutFromMetri = async (): Promise<void> => {
  const metriAddress = getMetriAddress();
  const payAddress = getPayAddress();

  const cleanupPromises = [
    deleteFCMToken(),
    deleteSubscription(metriAddress),
    deleteSubscription(payAddress),
  ];

  await Promise.allSettled(cleanupPromises);

  stateCirclesBasicInfoOnboardingData.set(null);

  const context = localStorage.getItem(`context`);
  const sent_invite_notification = localStorage.getItem(`sent_invite_notification`);
  const seen_lbp_guidance = localStorage.getItem(`${metriAddress}_seen_lbp_guidance`);
  const errorLogging = localStorage.getItem(`errorLogging`);
  const theme = localStorage.getItem(`darkTheme`);

  window.localStorage.clear();
  window.sessionStorage.clear();

  if (context) {
    localStorage.setItem(`context`, context);
  }
  if (sent_invite_notification) {
    localStorage.setItem(`sent_invite_notification`, sent_invite_notification);
  }
  if (seen_lbp_guidance) {
    localStorage.setItem(`${metriAddress}_seen_lbp_guidance`, seen_lbp_guidance);
  }

  if (errorLogging) {
    localStorage.setItem(`errorLogging`, errorLogging);
  }

  if (theme) {
    localStorage.setItem(`darkTheme`, 'true');
  }
};
